// extracted by mini-css-extract-plugin
export var card_topic = "project_card-module--card_topic--1UbcQ";
export var details = "project_card-module--details--1ehXd";
export var read_more = "project_card-module--read_more--3UZ_2";
export var card_image = "project_card-module--card_image--t4iTx";